import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import ProductInventoryLogGrid from '@sophocles/views/sales/components/ProductInventoryLogGrid';

function ProductInventoryLogView() {
  const { t } = useTranslation();

  const breadcrumbs = [
    { label: t('warehouse.sales', 'Sales'), to: '/sales/orders' },
    { label: t('general.products', 'Products'), to: '/sales/products' },
    { label: t('warehouse.inventoryLog', 'Inventory Log') },
  ];

  return (
    <AppNav flex notFullHeight loading={false} page="sales_products_inventory">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar breadcrumbs={breadcrumbs} />
        <ProductInventoryLogGrid />
      </Box>
    </AppNav>
  );
}

export default ProductInventoryLogView;
